export enum InsuranceCoverTypes {
  Lifetime = 'Lifetime',
}

export function isInsuranceCoverType(
  insuranceCoverTypeCandidate: string,
): insuranceCoverTypeCandidate is InsuranceCoverTypes {
  return insuranceCoverTypeCandidate in InsuranceCoverTypes;
}
